import { get, post, Response } from '@/api'
import {
  MediumProduct,
  ModelConfiguration,
  ModelGroupResource,
  ProductClass,
  ProductClassesPostDto
} from '@/types/index'

export default {
  getProductClasses: (): Promise<Response<ProductClass[]>> => {
    return get<ProductClass[]>('/cto/productclasses')
  },
  getModelGroups: (productClassId: string): Promise<Response<ModelGroupResource[]>> => {
    return get<ModelGroupResource[]>('/cto/modelgroup/' + productClassId)
  },
  getModelConfiguration: (
    manufacturerMaterialNo: string
  ): Promise<Response<ModelConfiguration>> => {
    return get<ModelConfiguration>('/cto/productclasses/' + manufacturerMaterialNo)
  },
  getProductInformation: (dto: ProductClassesPostDto): Promise<Response<MediumProduct>> => {
    return post<MediumProduct, ProductClassesPostDto>('/cto/productinformation', dto)
  }
}
